export enum SnippetTypesVariant {
  ALL = 'all',
  SPECIFIC = 'specific',
}
